export default __webpack_public_path__ + "f6c78a6c006f66f72e0a3d33714587bc.png";